// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2b8I5","input":"styles_input__APi6w"};